import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const fr = {
  brand: "Vytali Academy",
  nav: { dashboard: "Tableau de bord", courses: "Formations", journey: "Parcours Owner", trainer: "Espace Formateur", admin: "Console Admin", logout: "Déconnexion" },
  reset: {
    title: "Nouveau mot de passe",
    submit: "Réinitialiser le mot de passe",
    success: "Mot de passe réinitialisé. Redirection vers la connexion…",
    invalidToken: "Lien invalide ou expiré. Refaites une demande depuis « Mot de passe oublié ? ».",
  },
  register: {
    title: "S'inscrire à Vytali Academy",
    firstName: "Prénom", lastName: "Nom", phone: "Téléphone (optionnel)",
    confirm: "Confirmer le mot de passe", language: "Langue préférée",
    submit: "S'inscrire",
    approvalNotice: "Votre compte sera activé après approbation par un responsable Vytali.",
    haveAccount: "Déjà un compte ? Se connecter",
    success: "Votre inscription a bien été reçue. Votre compte est actuellement en attente d'approbation. Vous pourrez vous connecter dès qu'un responsable l'aura validé.",
    errInvalidEmail: "Adresse e-mail invalide.", errName: "Prénom et nom requis.",
    errShort: "Le mot de passe doit contenir au moins 8 caractères.",
    errMismatch: "Les mots de passe ne correspondent pas.",
    errExists: "Un compte existe déjà avec cette adresse e-mail.",
  },
  login: {
    title: "Vytali Academy", subtitle: "Formation. Certification. Préparation.",
    email: "Adresse e-mail", password: "Mot de passe", submit: "Se connecter",
    error: "E-mail ou mot de passe invalide",
    pendingApproval: "Votre inscription a bien été reçue. Votre compte est actuellement en attente d'approbation.",
    rejected: "Votre demande d'inscription n'a pas été retenue. Contactez votre administrateur pour plus d'informations.",
    suspended: "Votre compte est suspendu. Contactez votre administrateur.",
    signUp: "Créer un compte",
    forgot: "Mot de passe oublié ?",
    forgotIntro: "Saisissez votre adresse e-mail. Si un compte existe, vous recevrez un e-mail avec un lien de réinitialisation (valide 30 minutes).",
    forgotSubmit: "Envoyer la demande",
    forgotSent: "Si un compte existe pour cette adresse, un e-mail de réinitialisation vient d'être envoyé. Vérifiez aussi vos courriers indésirables.",
    backToLogin: "← Retour à la connexion",
    tagline: "La formation crée la connaissance. La certification confirme l'accomplissement. La promotion reste une décision humaine.",
  },
  dashboard: {
    title: "Que dois-je faire maintenant ?",
    nextAction: "Prochaine action recommandée",
    continueCourse: "Continuer la formation", enrollCourse: "Commencer la formation",
    noAction: "Aucune action recommandée pour le moment.",
    progress: "Progression", certifications: "Certifications", readiness: "Préparation Campagnes",
    journeyTitle: "Parcours Owner Model", viewJourney: "Voir le parcours complet",
    recommended: "Formations recommandées", currentStage: "Palier actuel", nextStage: "Palier suivant",
    noCerts: "Aucune certification pour le moment.", contentRequired: "Contenu officiel en attente",
  },
  courses: {
    title: "Catalogue de formations", enroll: "S'inscrire", open: "Ouvrir",
    enrolled: "Inscrit", assigned: "Assignée", school: "École",
    policy: { SELF_ENROLL: "Inscription libre", ASSIGNMENT_ONLY: "Sur assignation", RESTRICTED: "Restreint" },
    status: { DRAFT: "BROUILLON", CONTENT_REQUIRED: "CONTENU REQUIS", PUBLISHED: "PUBLIÉ", ARCHIVED: "ARCHIVÉ" },
    version: "Version", completed: "Complétée",
  },
  player: {
    modules: "Modules", quiz: "Quiz de validation", complete: "Marquer comme terminé",
    completed: "Terminé", resume: "Reprendre", start: "Commencer",
    videoPending: "Vidéo officielle en attente (CONTENT_REQUIRED)",
    objective: "Objectif pédagogique", structure: "Structure du module",
    draftPreview: "Structure non publiée — prévisualisation (CONTENT_REQUIRED). Inscription indisponible.",
    accessDenied: "Accès refusé par la politique d'inscription. Ce parcours n'est pas encore disponible.",
    demoContent: "Contenu de démonstration (DEMO)",
    progress: "Progression", startQuiz: "Passer le quiz",
    finishModulesFirst: "Terminez tous les modules pour débloquer le quiz",
    quizPassed: "Quiz réussi",
    enrolledToast: "Inscription confirmée",
    types: { TEXT: "TEXTE", VIDEO: "VIDÉO", QUIZ: "QUIZ", PRACTICE: "PRATIQUE", REFLECTION: "RÉFLEXION" },
  },
  quiz: {
    title: "Quiz", submit: "Soumettre mes réponses", attempt: "Tentative",
    of: "sur", passed: "Réussi ! Score : {{score}}%", failed: "Échec. Score : {{score}}%",
    feedback: "Retour par compétence", needsReview: "À revoir", mastered: "Maîtrisé",
    reviewRequired: "REVISION REQUISE — Un formateur ou un administrateur doit débloquer une nouvelle tentative.",
    reviewFirst: "Revoyez le contenu du cours avant de retenter.",
    confirmReview: "J'ai revu le contenu du cours", retry: "Retenter le quiz",
    attemptsRemaining: "Tentatives restantes : {{count}}",
    certEarned: "Certification obtenue !",
    comp: { progression: "Progression", certification: "Certification", readiness: "Préparation", architecture: "Concepts Academy", general: "Général" },
  },
  journey: {
    title: "Parcours Owner Model", current: "Palier actuel", completedStage: "Complété", next: "Suivant",
    recommendedTraining: "Formations recommandées", completedTraining: "Formations complétées",
    inProgress: "En cours", skillsToDevelop: "Compétences à développer",
    progressToNext: "Progression vers le palier suivant", readyForReview: "Prêt pour évaluation",
    humanDecision: "La promotion de palier est toujours une décision humaine.",
    noRecommended: "Aucune formation recommandée pour ce palier (contenu en attente).",
  },
  cert: {
    title: "Certificat", earnedOn: "Obtenu le", expiresOn: "Expire le", version: "Version du cours",
    status: { PASSED: "VALIDE", EXPIRED: "EXPIRÉE", REVOKED: "RÉVOQUÉE", IN_PROGRESS: "EN COURS", NOT_STARTED: "NON COMMENCÉE" },
    recertRequired: "Recertification requise",
  },
  readiness: {
    title: "Préparation Campagnes",
    status: { READY: "PRÊT", IN_PROGRESS: "EN COURS", NOT_READY: "NON PRÊT", UPDATE_REQUIRED: "MISE À JOUR REQUISE", BLOCKED: "BLOQUÉ" },
    met: "Exigences satisfaites", missing: "Exigences manquantes", evaluated: "Évalué le",
    noExternal: "La préparation est interne à l'Academy — aucune permission opérationnelle externe.",
  },
  trainer: {
    title: "Espace Formateur", learners: "Mes apprenants (cohorte)", reviewRequired: "Révision requise",
    attempts: "Historique des tentatives", unlock: "Débloquer une tentative",
    unlockReason: "Raison du déblocage", confirmUnlock: "Confirmer le déblocage",
    noLearners: "Aucun apprenant dans votre cohorte.", score: "Score", enrollments: "Inscriptions",
    stage: "Palier", unlocked: "Tentative débloquée",
    coaching: "Coaching", coachingView: "Vue Coaching", role: "Rôle",
    lastActivity: "Dernière activité", certifications: "Certifications", courses: "Formations assignées",
    completion: "Progression", certHistory: "Historique des certifications",
    nextAction: "Prochaine action recommandée", continueCourse: "Poursuivre",
    enrollCourse: "S'inscrire à", noNextAction: "Aucune action recommandée pour le moment.",
    notes: "Notes privées de coaching", noteCategories: { NOTE: "Note", STRENGTH: "Force", DEVELOPMENT: "Axe de développement" },
    addNote: "Ajouter la note", notePlaceholder: "Écrire une note privée…",
    noteAdded: "Note enregistrée", noteUpdated: "Note mise à jour", edit: "Modifier",
    noNotes: "Aucune note pour le moment.", selectLearner: "Sélectionnez un apprenant pour ouvrir la vue coaching.",
    privateNotice: "Les notes sont privées au formateur. Aucune action sensible (promotion, certification, préparation, rôle) n'est possible ici — décisions réservées Owner/Admin.",
    noCerts: "Aucune certification.",
  },
  admin: {
    title: "Console Admin", users: "Utilisateurs", coursesTab: "Formations", assignments: "Assignations",
    registrations: "Demandes d'inscription",
    campaigns: "Campagnes & Préparation", certifications: "Certifications", audit: "Journal d'audit",
    knowledge: "Connaissances",
    changeStage: "Changer le palier", newStage: "Nouveau palier", reason: "Raison (optionnel)",
    confirm: "Confirmer", assign: "Assigner", learner: "Apprenant", course: "Formation",
    source: "Source", publish: "Publier", newVersion: "Nouvelle version",
    evaluate: "Évaluer la préparation", requireRecert: "Exiger recertification",
    revoke: "Révoquer", role: "Rôle", stage: "Palier", email: "E-mail", name: "Nom",
    event: "Événement", actor: "Acteur", when: "Date", versions: "Versions",
    stageChanged: "Palier modifié", assigned: "Assignation créée",
  },
  common: {
    loading: "Chargement…", error: "Une erreur est survenue", save: "Enregistrer",
    cancel: "Annuler", demo: "DEMO", close: "Fermer", back: "Retour",
  },
  home: {
    tagline: "De l\u2019exp\u00e9rience terrain au d\u00e9veloppement des leaders de demain.",
    cta: "Acc\u00e9der \u00e0 l\u2019Academy",
    principleTitle: "Principe fondateur",
    p1: "La formation cr\u00e9e la connaissance.",
    p2: "La certification confirme l\u2019accomplissement.",
    p3: "La pr\u00e9paration \u00e9value les exigences.",
    p4: "La promotion de carri\u00e8re reste une d\u00e9cision humaine.",
    p5: "La permission op\u00e9rationnelle reste externe \u00e0 l\u2019Academy.",
    schoolsTitle: "Cinq \u00e9coles",
    s1: "Vente & Acquisition", s2: "Owner Model & Leadership", s3: "Campaign OS",
    s4: "Ambassadeurs & R\u00e9seau", s5: "Culture & Standards",
    journeyTitle: "Le parcours Owner Model",
  },
};

const en = {
  brand: "Vytali Academy",
  nav: { dashboard: "Dashboard", courses: "Courses", journey: "Owner Journey", trainer: "Trainer Space", admin: "Admin Console", logout: "Log out" },
  reset: {
    title: "New password",
    submit: "Reset password",
    success: "Password reset. Redirecting to sign in…",
    invalidToken: "Invalid or expired link. Request a new one via \"Forgot password?\".",
  },
  register: {
    title: "Sign up for Vytali Academy",
    firstName: "First name", lastName: "Last name", phone: "Phone (optional)",
    confirm: "Confirm password", language: "Preferred language",
    submit: "Sign up",
    approvalNotice: "Your account will be activated after approval by a Vytali manager.",
    haveAccount: "Already have an account? Sign in",
    success: "Your registration has been received. Your account is currently awaiting approval. You will be able to sign in once a manager validates it.",
    errInvalidEmail: "Invalid email address.", errName: "First and last name required.",
    errShort: "Password must be at least 8 characters.",
    errMismatch: "Passwords do not match.",
    errExists: "An account already exists with this email address.",
  },
  login: {
    title: "Vytali Academy", subtitle: "Training. Certification. Readiness.",
    email: "Email address", password: "Password", submit: "Sign in",
    error: "Invalid email or password",
    pendingApproval: "Your registration has been received. Your account is currently awaiting approval.",
    rejected: "Your registration request was not accepted. Contact your administrator for more information.",
    suspended: "Your account is suspended. Contact your administrator.",
    signUp: "Create an account",
    forgot: "Forgot password?",
    forgotIntro: "Enter your email address. If an account exists, you will receive an email with a reset link (valid 30 minutes).",
    forgotSubmit: "Send request",
    forgotSent: "If an account exists for this address, a reset email has just been sent. Also check your spam folder.",
    backToLogin: "← Back to sign in",
    tagline: "Training creates knowledge. Certification confirms achievement. Promotion remains a human decision.",
  },
  dashboard: {
    title: "What should I do next?",
    nextAction: "Next recommended action",
    continueCourse: "Continue training", enrollCourse: "Start training",
    noAction: "No recommended action right now.",
    progress: "Progress", certifications: "Certifications", readiness: "Campaign Readiness",
    journeyTitle: "Owner Model Journey", viewJourney: "View full journey",
    recommended: "Recommended courses", currentStage: "Current stage", nextStage: "Next stage",
    noCerts: "No certifications yet.", contentRequired: "Official content pending",
  },
  courses: {
    title: "Course catalog", enroll: "Enroll", open: "Open",
    enrolled: "Enrolled", assigned: "Assigned", school: "School",
    policy: { SELF_ENROLL: "Self-enroll", ASSIGNMENT_ONLY: "Assignment only", RESTRICTED: "Restricted" },
    status: { DRAFT: "DRAFT", CONTENT_REQUIRED: "CONTENT REQUIRED", PUBLISHED: "PUBLISHED", ARCHIVED: "ARCHIVED" },
    version: "Version", completed: "Completed",
  },
  player: {
    modules: "Modules", quiz: "Validation quiz", complete: "Mark as complete",
    completed: "Completed", resume: "Resume", start: "Start",
    videoPending: "Official video pending (CONTENT_REQUIRED)",
    objective: "Learning objective", structure: "Module structure",
    draftPreview: "Unpublished structure — preview (CONTENT_REQUIRED). Enrollment unavailable.",
    accessDenied: "Access denied by enrollment policy. This path is not yet available.",
    demoContent: "Demonstration content (DEMO)",
    progress: "Progress", startQuiz: "Take the quiz",
    finishModulesFirst: "Complete all modules to unlock the quiz",
    quizPassed: "Quiz passed",
    enrolledToast: "Enrollment confirmed",
    types: { TEXT: "TEXT", VIDEO: "VIDEO", QUIZ: "QUIZ", PRACTICE: "PRACTICE", REFLECTION: "REFLECTION" },
  },
  quiz: {
    title: "Quiz", submit: "Submit my answers", attempt: "Attempt",
    of: "of", passed: "Passed! Score: {{score}}%", failed: "Failed. Score: {{score}}%",
    feedback: "Competency feedback", needsReview: "Needs review", mastered: "Mastered",
    reviewRequired: "REVIEW REQUIRED — A trainer or admin must unlock a new attempt.",
    reviewFirst: "Review the course content before retrying.",
    confirmReview: "I have reviewed the course content", retry: "Retry quiz",
    attemptsRemaining: "Attempts remaining: {{count}}",
    certEarned: "Certification earned!",
    comp: { progression: "Progression", certification: "Certification", readiness: "Readiness", architecture: "Academy concepts", general: "General" },
  },
  journey: {
    title: "Owner Model Journey", current: "Current stage", completedStage: "Completed", next: "Next",
    recommendedTraining: "Recommended training", completedTraining: "Completed training",
    inProgress: "In progress", skillsToDevelop: "Skills to develop",
    progressToNext: "Progress toward next stage", readyForReview: "Ready for review",
    humanDecision: "Stage promotion is always a human decision.",
    noRecommended: "No recommended training for this stage (content pending).",
  },
  cert: {
    title: "Certificate", earnedOn: "Earned on", expiresOn: "Expires on", version: "Course version",
    status: { PASSED: "VALID", EXPIRED: "EXPIRED", REVOKED: "REVOKED", IN_PROGRESS: "IN PROGRESS", NOT_STARTED: "NOT STARTED" },
    recertRequired: "Recertification required",
  },
  readiness: {
    title: "Campaign Readiness",
    status: { READY: "READY", IN_PROGRESS: "IN PROGRESS", NOT_READY: "NOT READY", UPDATE_REQUIRED: "UPDATE REQUIRED", BLOCKED: "BLOCKED" },
    met: "Requirements met", missing: "Requirements missing", evaluated: "Evaluated on",
    noExternal: "Readiness is Academy-internal — no external operational permission.",
  },
  trainer: {
    title: "Trainer Space", learners: "My learners (cohort)", reviewRequired: "Review required",
    attempts: "Attempt history", unlock: "Unlock an attempt",
    unlockReason: "Unlock reason", confirmUnlock: "Confirm unlock",
    noLearners: "No learners in your cohort.", score: "Score", enrollments: "Enrollments",
    stage: "Stage", unlocked: "Attempt unlocked",
    coaching: "Coaching", coachingView: "Coaching View", role: "Role",
    lastActivity: "Last activity", certifications: "Certifications", courses: "Assigned courses",
    completion: "Completion", certHistory: "Certification history",
    nextAction: "Next recommended action", continueCourse: "Continue",
    enrollCourse: "Enroll in", noNextAction: "No recommended action at the moment.",
    notes: "Private coaching notes", noteCategories: { NOTE: "Note", STRENGTH: "Strength", DEVELOPMENT: "Development opportunity" },
    addNote: "Add note", notePlaceholder: "Write a private note…",
    noteAdded: "Note saved", noteUpdated: "Note updated", edit: "Edit",
    noNotes: "No notes yet.", selectLearner: "Select a learner to open the coaching view.",
    privateNotice: "Notes are private to the trainer. No sensitive action (promotion, certification, readiness, role) is possible here — Owner/Admin decisions only.",
    noCerts: "No certifications.",
  },
  admin: {
    title: "Admin Console", users: "Users", coursesTab: "Courses", assignments: "Assignments",
    registrations: "Registration requests",
    campaigns: "Campaigns & Readiness", certifications: "Certifications", audit: "Audit log",
    knowledge: "Knowledge",
    changeStage: "Change stage", newStage: "New stage", reason: "Reason (optional)",
    confirm: "Confirm", assign: "Assign", learner: "Learner", course: "Course",
    source: "Source", publish: "Publish", newVersion: "New version",
    evaluate: "Evaluate readiness", requireRecert: "Require recertification",
    revoke: "Revoke", role: "Role", stage: "Stage", email: "Email", name: "Name",
    event: "Event", actor: "Actor", when: "Date", versions: "Versions",
    stageChanged: "Stage changed", assigned: "Assignment created",
  },
  common: {
    loading: "Loading…", error: "An error occurred", save: "Save",
    cancel: "Cancel", demo: "DEMO", close: "Close", back: "Back",
  },
  home: {
    tagline: "From field experience to developing tomorrow\u2019s leaders.",
    cta: "Enter the Academy",
    principleTitle: "Founding principle",
    p1: "Training creates knowledge.",
    p2: "Certification confirms achievement.",
    p3: "Readiness evaluates requirements.",
    p4: "Career promotion remains a human decision.",
    p5: "Operational permission remains external to the Academy.",
    schoolsTitle: "Five schools",
    s1: "Sales & Acquisition", s2: "Owner Model & Leadership", s3: "Campaign OS",
    s4: "Ambassadors & Network", s5: "Culture & Standards",
    journeyTitle: "The Owner Model Journey",
  },
};

i18n.use(initReactI18next).init({
  resources: { fr: { translation: fr }, en: { translation: en } },
  lng: localStorage.getItem("vytali_lang") || "fr",
  fallbackLng: "fr",
  interpolation: { escapeValue: false },
});

export default i18n;
